import {
  updateSettlementAccount,
  getSettlementBankList,
  resolveSettlementAccountNumber,
} from "../../../services/settlements";
import { useEffect, useContext, useState } from "react";
import { ToastContext, RequestLoader } from "../../../hooks/context";
import { useSelector } from "react-redux";
// import { useSelector } from "react-redux";

const EditSettlementAccountLogic = (
  setIsOpen,
  settlementAccount,
  handleFetchSettlementAccounts,
) => {
  // const {} = settlementAccount;
  const {
    id,
    decrypted_bank_code,
    // decrypted_bank_code,
    decrypted_nuban,
    is_primary: isPrimaryAcc,
    businesses,
  } = settlementAccount;
  const [bank, setBank] = useState(decrypted_bank_code || "");
  const [bankList, setBankList] = useState([]);
  const [account_number, setAccountNumber] = useState(decrypted_nuban || "");
  const [business_id, setBusinessId] = useState(businesses?.[0]?.id || null);
  const [is_primary, setIsPrimary] = useState(isPrimaryAcc || false);
  const [isUpdatingAccount, setIsUpdatingAccount] = useState(false);
  const [isResolvingAccount, setIsResolvingAccount] = useState(false);
  const [isFetchingBankList, setIsFetchingBankList] = useState(false);
  const [isValidAccountNumber, setIsValidAccountNumber] = useState(false);
  const [accountDetails, setAccountDetails] = useState(null);
  const [isEdited, setIsEdited] = useState(false);
  // const [business_list, setBusinessList] = useState([]);
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const { business_list } = useSelector(
    (state) => state.profileDetailsReducer.profileDetails,
  );

  useEffect(() => {
    if (business_id) fetchBankList();
  }, [business_id]);

  const handleResolveAccountNumber = (account_number, bank_code) => {
    setIsResolvingAccount(true);
    resolveSettlementAccountNumber(
      {
        account_number,
        bank_code: bank_code,
      },
      business_id,
    )
      .then((response) => {
        setIsValidAccountNumber(true);
        setIsResolvingAccount(false);
        setAccountDetails(response.data.data);
      })
      .catch((error) => {
        setIsResolvingAccount(false);
      });
  };

  const fetchBankList = () => {
    setIsFetchingBankList(true);
    setRequestLoaderProgress(40);

    getSettlementBankList(business_id)
      .then((response) => {
        setIsFetchingBankList(false);
        setRequestLoaderProgress(100);
        setBankList(response.data?.data);
      })
      .catch((error) => {
        setIsFetchingBankList(false);
        setRequestLoaderProgress(100);
      });
  };

  const handleUpdateSettlementAccount = () => {
    setIsUpdatingAccount(true);
    setRequestLoaderProgress(40);

    updateSettlementAccount(id, {
      currency: business_list?.find(
        (business) => `${business?.id}` === `${business_id}`,
      )?.currency_code,
      bank_code: bank,
      nuban: account_number,
      is_primary,
      business_id: business_id,
    })
      .then(() => {
        triggerToast("Updated successfully", "success");
        handleFetchSettlementAccounts();
        setIsUpdatingAccount(false);
        setRequestLoaderProgress(100);
        setIsOpen(false);
      })
      .catch((error) => {
        setIsUpdatingAccount(false);
        setRequestLoaderProgress(100);
      });
  };

  return {
    bank,
    account_number,
    is_primary,
    isUpdatingAccount,
    isResolvingAccount,
    isFetchingBankList,
    bankList,
    accountDetails,
    isValidAccountNumber,
    isEdited,
    business_list,
    business_id,
    setBusinessId,
    setIsEdited,
    setIsPrimary,
    setAccountNumber,
    setBank,
    handleResolveAccountNumber,
    handleUpdateSettlementAccount,
  };
};

export default EditSettlementAccountLogic;
